import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Icon from './customButtonPsCopyIcon.svg';

export class CustomButtonPsCopy extends Plugin {
  init() {
    const editor = this.editor;

    // このプラグイン用の設定を取得
    const customButtonPsCopyConfig = editor.config.get('customButtonPsCopy');
    if (customButtonPsCopyConfig && customButtonPsCopyConfig.onClick) {
      editor.ui.componentFactory.add('customButtonPsCopy', () => {
        const button = new ButtonView();

        button.set({
          label: editor.t('コピー'),
          icon: Icon,
          withText: true,
        });

        button.on('execute', () => {
          customButtonPsCopyConfig.onClick();
        });

        return button;
      });
    }
  }
}
